import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
import { Form, Input, Spin, Row, Col, Checkbox, Skeleton } from 'antd';
import classnames from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';

import { infoCb } from '@/service';
import _ from 'lodash';
import NodeRSA from 'node-rsa';
import myContext from '@/utils/createContext';
import { getUrlParams, gtag } from '@/utils/index.js';
import { getDomainFromUrlStr, getDomainStr } from '@/components/H5PC/utils'

import allRegex from '@/components/allRegex.js';
import AgreementModal from './AgreementModal';
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;

const key = getUrlParams('key'); // 从 URL 中获取 key
function UnionPay(props) {
  const intl = props.intl;
  const cardRef = useRef();

  // const form = props.form;
  const { form, initData, bankCode, setBankCode, isMobileView, resData } = useContext(
    myContext,
  );
  let showDomain = '';

  if(typeof window!= 'undefined' && getDomainFromUrlStr()){
    showDomain = getDomainStr(resData)
  }
  const h5OrWeb = isMobileView ? 'H5' : 'WEB';

  let [activeLoading, setActiveLoading] = useState(true);
  useEffect(() => {
    if (!_.isEmpty(initData)) {
      setTimeout(() => {
        setActiveLoading(false);
      }, 500);
    }
  }, [initData]);

  const [curBankCode, setCurBankCode] = useState('');
  const [isModalVisible, setIsModalVisible] = useState('');
  const [checked, setChecked] = useState(false);

  const suffixCardNumber = () => {
    const src = `/static/images/bank/ic_${curBankCode}.png`;
    return (
      <div>
        {curBankCode !== '' ? (
          <div className="h5-card-elements-suffix-list">
            <img src={src} />
          </div>
        ) : null}
      </div>
    );
  };

  const onBlurCardNumber = async function(e) {
    gtag(`${showDomain}支付页面`, [new Date() + '输入卡号']);
    gtag(`${showDomain}支付页面`, ['输入卡号']);
    showDomain ? gtag(`定制支付页面`, ['输入卡号']):'';
    

    debounceCardNumberFn();
  };

  const onBlurCardName = async function(e){
    gtag(`${showDomain}支付页面`, [new Date() + '输入姓名']);
    gtag(`${showDomain}支付页面`, ['输入姓名']);
    showDomain ? gtag(`定制支付页面`, ['输入姓名']):'';

  }

  const onBlurCardIDCard = async function(e){
    gtag(`${showDomain}支付页面`, [new Date() + '输入身份证']);
    gtag(`${showDomain}支付页面`, ['输入身份证']);
    showDomain ? gtag(`定制支付页面`, ['输入身份证']):'';
  }

  const onBlurCardPhone = async function(e){
    gtag(`${showDomain}支付页面`, [new Date() + '输入银行手机号']);
    gtag(`${showDomain}支付页面`, ['输入银行手机号']);
    showDomain ? gtag(`定制支付页面`, ['输入银行手机号']):'';
  }

  const debounceCardNumberFn = async function(e) {
    const cardNoNull = form.getFieldValue('cardNo') || '';
    const cardNo = cardNoNull.replace(/\s*/g, '');
    // 当卡号位数小于16位，不去调用卡bin接口
    if (cardNo.length < 16) {
      return;
    }
    const params = { cardNo };
    // console.log('paymentParams:', params);
    // 加密
    const pubKey = new NodeRSA(initData.publicKey, 'pkcs8-public');
    const newParams = JSON.parse(JSON.stringify(params));
    pubKey.setOptions({
      encryptionScheme: 'pkcs1',
    }); // 必须得加，要和java加密解密统一
    const encrypted = pubKey.encrypt(newParams, 'base64');
    // 加密后的参数
    const paramsEncrypted = {
      encrypted,
      token: initData.token,
    };

    const res = await infoCb(key, paramsEncrypted);

    if (res && res.code === 200000) {
      const bankCode = res?.data?.bankCode || '';
      const bankName = res?.data?.bankName;
      setCurBankCode(bankCode);
      // 通过context传递bankCode值
      setBankCode(bankCode);
    } else {
      setCurBankCode('');
    }
  };
  // 动态改变label的class的值值
  const setRefChange = cref => {
    // console.log(2222, cref.current);
    if (!_.isEmpty(cref.current)) {
      cref.current.setLabelClass();
    }
  };

  const agreementOnChange = e => {
    if (e.target.checked === true) {
      setChecked(e.target.checked);
    } else {
      setChecked('');
    }
  };
  return (
    <Skeleton
      loading={activeLoading}
      active={true}
      title={false}
      // style={{ padding: 100 }}
      paragraph={{ rows: 9 }}
    >
      <div className="h5pc-card-paid">
        <Row gutter={20} style={{ marginBottom: '10px' }}>
          <Col span={24}>
            {/* 对应的卡组织 */}
            {suffixCardNumber()}
            <FloatLabel
              form={form}
              name="cardNo"
              label="Card Number 卡号"
              className="ant-form-item-required"
              rules={[
                {
                  required: true,
                  message: `Please enter your card number(输入卡号)`,
                },
                ({ getFieldValue }) => ({
                  validator: async (rule, value) => {
                    if (_.isEmpty(value)) return;
                    let newVal = value.replace(/\s*/g, '');
                    if (!/^[1-9]\d{15,19}$/.test(newVal)) {
                      return Promise.reject(
                        'Please enter your right card number(输入正确的卡号)',
                      );
                    }
                  },
                }),
              ]}
              getValueFromEvent={e => {
                let val = e.target.value;
                let newVal = val.replace(/[^0-9]/gi, ''); // 替换字符串中的所有的非数字
                if (/^\d{1,}$/g.test(newVal)) {
                  newVal = newVal.replace(/(\d{4})(?=\d)/g, '$1 ');
                  e.target.value = newVal;
                  return e.target.value;
                } else {
                  return e.target.value.replace(/\D/g, '');
                }
              }}
            >
              <Input
                size="large"
                type="tel"
                maxLength={23}
                minLength={19}
                onBlur={e => onBlurCardNumber(e)}
              />
            </FloatLabel>
          </Col>
        </Row>
        <Row gutter={20} style={{ marginBottom: '10px' }}>
          <Col span={24}>
            <FloatLabel
              form={form}
              name="cardName"
              label="Full Name 姓名(如:张三)"
              className="ant-form-item-required"
              rules={[
                {
                  required: true,
                  message: `Please enter your name(输入姓名)`,
                },
                {
                  pattern: /^(?:[\u4e00-\u9fa5·]{2,16})$/,
                  message: 'Please enter your Chinese name(输入中文名)',
                },
              ]}
            >
              <Input size="large" maxLength={15} onBlur={e => onBlurCardName(e)} />
            </FloatLabel>
          </Col>
        </Row>
        <Row gutter={20} style={{ marginBottom: '10px' }}>
          <Col span={24}>
            <FloatLabel
              form={form}
              name="idNo"
              label="ID 身份证号"
              className="ant-form-item-required"
              rules={[
                {
                  required: true,
                  message: `Please enter your ID number(输入身份证号)`,
                },
                {
                  pattern: allRegex.idCardReg,
                  message:
                    'Incorrect ID number. Please try again(身份证号错误)',
                },
              ]}
            >
              <Input size="large" maxLength={18} onBlur={e => onBlurCardIDCard(e)}  />
            </FloatLabel>
          </Col>
        </Row>
        <Row gutter={20} style={{ marginBottom: '10px' }}>
          <Col span={24}>
            <FloatLabel
              form={form}
              name="phoneNumber"
              label="Phone 银行预留手机号"
              className="ant-form-item-required"
              rules={[
                {
                  required: true,
                  message: `Please enter your bank registered phone(输入手机号)`,
                },
                {
                  pattern: allRegex.phoneReg,
                  message:
                    'Incorrect phone number. Please try again(手机号错误)',
                },
              ]}
              getValueFromEvent={e => {
                let val = e.target.value;
                let newVal = val.replace(/[^0-9]/gi, ''); // 替换字符串中的所有的非数字
                e.target.value = newVal;
                return e.target.value;
              }}
            >
              <Input size="large" type="tel" maxLength={11} onBlur={e => onBlurCardPhone(e)}/>
            </FloatLabel>
          </Col>
        </Row>
        <Row gutter={20} style={{ marginBottom: '10px' }}>
          <Col span={24}>
            <FormItem
              name="agreement"
              // rules={[
              //   {
              //     required: true,
              //     message: '请勾选协议后支付',
              //   },
              // ]}
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(new Error('请勾选协议后支付')),
                },
              ]}
            >
              <Checkbox>
                <>
                  <span style={{ fontSize: '14px' }}>我已阅读并同意</span>
                  {isMobileView ? (
                    <AgreementModal />
                  ) : (
                    <a href="/agreement/index.html" target="_blank">
                      <span style={{ fontSize: '14px' }}>
                        《银联卡支付服务协议》
                      </span>
                    </a>
                  )}
                </>
              </Checkbox>
              {/* <CheckboxGroup
                defaultValue={'我已经阅读并接受'}
                options={[
                  {
                    value: '我已阅读并同意',
                    label: (
                      <>
                        <span style={{ fontSize: '14px' }}>我已阅读并同意</span>
                        {isMobileView ? (
                          <AgreementModal />
                        ) : (
                          <a href="/agreement/index.html" target="_blank">
                            <span style={{ fontSize: '14px' }}>
                              《银联卡支付服务协议》
                            </span>
                          </a>
                        )}
                      </>
                    ),
                  },
                ]}
              ></CheckboxGroup> */}
            </FormItem>
          </Col>
        </Row>
      </div>
    </Skeleton>
  );
}

export default injectIntl(UnionPay);
